//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pako from 'pako'
import { undoUrlSafeBase64, escapeHtml } from '../../helpers/utils'
import footer from '~/components/footer.vue'
export default {
  components: { footer },
  layout: 'main',
  data() {
    return {
      lhsDiff: this.lhsDiff,
      rhsDiff: this.rhsDiff,
      rhsLabel: this.rhsLabel,
      lhsLabel: this.lhsLabel,
      copied: false,
    }
  },
  mounted() {
    const _diff = this.$route.hash
    const gunzip = pako.ungzip(Buffer.from(undoUrlSafeBase64(_diff), 'base64'))
    const diffData = JSON.parse(Buffer.from(gunzip).toString('utf8'))
    const { diff, lhsLabel, rhsLabel } = diffData
    this.lhsLabel = lhsLabel
    this.rhsLabel = rhsLabel
    this.lhsDiff = diff
      .map((item) => {
        const hunkState = item[0]
        if (hunkState === -1 || hunkState === 0) {
          const className =
            hunkState === -1
              ? 'isModified bg-red-300 dark:bg-yellow-900 mix-blend-overlay'
              : ''
          return `<span class="break-all inline p-0 m-0 ${className}">${escapeHtml(
            item[1]
          )}</span>`
        }
        return false
      })
      .filter(Boolean)
      .join('')
      .split('\n')
    this.rhsDiff = diff
      .map((item) => {
        const hunkState = item[0]
        if (hunkState === 1 || hunkState === 0) {
          const className =
            hunkState === 1
              ? 'isModified bg-green-300 dark:bg-green-900 mix-blend-overlay'
              : ''
          return `<span class="break-all inline p-0 m-0 ${className}">${escapeHtml(
            item[1]
          )}</span>`
        }
        return false
      })
      .filter(Boolean)
      .join('')
      .split('\n')
    const maxLineCount =
      this.lhsDiff.length > this.rhsDiff.length
        ? this.lhsDiff.length
        : this.rhsDiff.length
    document.documentElement.style.setProperty(
      '--max-line-number-characher',
      `${`${maxLineCount}`.split('').length}ch`
    )
  },
  methods: {
    putToClipboard(textToPut, toastContent) {
      navigator.clipboard.writeText(textToPut)
      this.$store.commit('toast/show', {
        show: true,
        content: toastContent,
        iconHTML: `
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        `,
        theme: 'success',
      })
    },
    copyUrlToClipboard() {
      this.putToClipboard(window.location.href, 'Link copied to your clipboard')
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 5000)
    },
    copyTextToClipboard(e) {
      this.putToClipboard(
        e.currentTarget.parentNode.parentNode.innerText
          .split('\n\n')
          .join('\n'),
        'Text copied to your clipboard'
      )
    },
  },
}
